import React, { useState, useEffect } from "react";
import ResourceAccordion from "../components/NestedAccordion/ResourceAccordion";
import { Folder, Eyes, Downloads } from "../assets/svg/svgResources";
import BubbleDocuments from "../components/Resources/BubbleDocuments";
import { useNavigate, useSearchParams } from "react-router-dom";
import { skillsData } from "../assets/data/courses";

const Resources = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [currentContent, setCurrentContent] = useState({
    title: "",
    key: null,
    video: null,
    document: [],
  });

  const [documentLink, setDocumentLink] = useState("");
  const [folderDialog, setFolderDialog] = useState(false);
  const [activeDialog, setActiveDialog] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [mlopsAuthStatus, setMlopsAuthStatus] = useState(false);
  const [aiAuthStatus, setAiAuthStatus] = useState(false);

  // Check MLOps authentication status
  const checkMLOpsAccess = () => {
    const authTime = localStorage.getItem("auth_mlops");
    if (authTime) {
      const currentTime = new Date().getTime();
      const authTimestamp = parseInt(authTime);
      return currentTime - authTimestamp < 24 * 60 * 60 * 1000;
    }
    return false;
  };

  // Check AI authentication status
  const checkAIAccess = () => {
    const authTime = localStorage.getItem("auth_ai");
    if (authTime) {
      const currentTime = new Date().getTime();
      const authTimestamp = parseInt(authTime);
      return currentTime - authTimestamp < 24 * 60 * 60 * 1000;
    }
    return false;
  };

  // Update auth status on mount and periodically
  useEffect(() => {
    const checkAuth = () => {
      setMlopsAuthStatus(checkMLOpsAccess());
      setAiAuthStatus(checkAIAccess());
    };

    checkAuth();
    const interval = setInterval(checkAuth, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const handleMLOpsLogout = () => {
    localStorage.removeItem("auth_mlops");
    setMlopsAuthStatus(false);
  };

  const handleAILogout = () => {
    localStorage.removeItem("auth_ai");
    setAiAuthStatus(false);
  };

  // Find content by key in skillsData
  const findContentByKey = (key) => {
    if (!key) return null;

    console.log("Searching for key:", key);

    // Loop through all categories in skillsData
    for (const category in skillsData) {
      console.log("Checking category:", category);
      const categoryData = skillsData[category];

      // Check if categoryData is an object and has children
      if (
        typeof categoryData === "object" &&
        categoryData !== null &&
        categoryData.children
      ) {
        const children = categoryData.children;

        // If children is an object, search through its properties
        if (typeof children === "object" && children !== null) {
          console.log("Searching in children object of category:", category);

          // First level search
          for (const childKey in children) {
            const child = children[childKey];
            if (child && child.key === key) {
              console.log("Found matching item:", child);
              return {
                ...child,
                document: child.document || [],
              };
            }

            // Second level search (if child has its own children)
            if (child && typeof child === "object" && child.children) {
              for (const subChildKey in child.children) {
                const subChild = child.children[subChildKey];
                if (subChild && subChild.key === key) {
                  console.log("Found matching item in sub-children:", subChild);
                  return {
                    ...subChild,
                    document: subChild.document || [],
                  };
                }
              }
            }
          }
        }
      }
    }

    console.log("No content found for key:", key);
    return null;
  };

  // Initialize content from URL params
  useEffect(() => {
    const contentKey = searchParams.get("key");
    console.log("Loading content for key:", contentKey);

    if (contentKey) {
      const content = findContentByKey(contentKey);
      console.log("Found content:", content);

      if (content) {
        setCurrentContent(content);
      }
    }
  }, []); // Only run on mount

  // Update URL when content changes
  useEffect(() => {
    if (currentContent.key) {
      setSearchParams({ key: currentContent.key });
    }
  }, [currentContent.key]);

  const handleContentChange = (content) => {
    if (content && content.key) {
      setCurrentContent(content);
    }
  };

  const handleFolderDialogToggle = () => {
    setFolderDialog(!folderDialog);
  };

  const [timeoutId, setTimeoutId] = useState(null);

  const handleDialogToggle = (data) => {
    setActiveDialog(data);
    setIsLoading(true); // Bắt đầu trạng thái loading

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const id = setTimeout(() => {
      setIsLoading(false); // Kết thúc trạng thái loading
      setErrorDialog(true);
      console.error("Tài liệu không tải được trong vòng 1 phút.");
      setTimeout(() => {
        setErrorDialog(false); // Ẩn dialog lỗi
      }, 2000);
    }, 10000);
    setTimeoutId(id); // Lưu ID của timeout
  };

  const handleDocumentLoad = () => {
    setIsLoading(false);
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
  };

  const renderLoading = () => {
    return (
      <div className="absolute top-0 left-0 flex justify-center items-center h-[92%] w-[100%]">
        <span className="text-lg font-semibold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-10 h-10 animate-spin animate-fade-red"
          >
            <path
              fillRule="evenodd"
              d="M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.25 6a.75.75 0 0 0-1.5 0v4.94l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V9.75Z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </div>
    );
  };

  useEffect(() => {
    if (
      activeDialog === "studyGuide" ||
      activeDialog === "document" ||
      activeDialog === "exercise"
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [activeDialog]);

  // Find next video
  const findNextVideo = (currentKey) => {
    if (!currentKey) return null;

    let foundCurrent = false;
    let nextVideo = null;

    // Loop through all categories
    for (const category in skillsData) {
      const categoryData = skillsData[category];
      if (
        typeof categoryData === "object" &&
        categoryData !== null &&
        categoryData.children
      ) {
        const children = categoryData.children;

        // Search through children
        for (const childKey in children) {
          const child = children[childKey];

          if (foundCurrent && child && child.video) {
            return child;
          }

          if (child && child.key === currentKey) {
            foundCurrent = true;
          }

          // Check sub-children
          if (child && typeof child === "object" && child.children) {
            for (const subChildKey in child.children) {
              const subChild = child.children[subChildKey];

              if (foundCurrent && subChild && subChild.video) {
                return subChild;
              }

              if (subChild && subChild.key === currentKey) {
                foundCurrent = true;
              }
            }
          }
        }
      }
    }

    return nextVideo;
  };

  const handleNextVideo = () => {
    const nextVideo = findNextVideo(currentContent.key);
    if (nextVideo) {
      handleContentChange(nextVideo);
    }
  };

  // Find previous video
  const findPrevVideo = (currentKey) => {
    if (!currentKey) return null;
    let prev = null;
    let foundCurrent = false;
    // Duyệt qua tất cả các category
    for (const category in skillsData) {
      const categoryData = skillsData[category];
      if (
        typeof categoryData === "object" &&
        categoryData !== null &&
        categoryData.children
      ) {
        const children = categoryData.children;
        for (const childKey in children) {
          const child = children[childKey];
          // Check sub-children
          if (child && typeof child === "object" && child.children) {
            for (const subChildKey in child.children) {
              const subChild = child.children[subChildKey];
              if (subChild && subChild.key === currentKey) {
                return prev;
              }
              if (subChild && subChild.video) {
                prev = subChild;
              }
            }
          }
          if (child && child.key === currentKey) {
            return prev;
          }
          if (child && child.video) {
            prev = child;
          }
        }
      }
    }
    return null;
  };

  const handlePrevVideo = () => {
    const prevVideo = findPrevVideo(currentContent.key);
    if (prevVideo) {
      handleContentChange(prevVideo);
    }
  };

  return (
    <>
      <main className="relative h-[100vh] w-[100vw] flex flex-col select-none pt-[60px] bg-black/95 overflow-hidden">
        {/* Cyberpunk grid background */}
        <div className="absolute inset-0 opacity-5">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(cyan 1px, transparent 1px),
              linear-gradient(90deg, cyan 1px, transparent 1px)
            `,
              backgroundSize: "50px 50px",
            }}
          ></div>
        </div>

        <div
          className={`flex ${
            showSidebar ? "max-sm:flex-col-reverse" : "max-sm:flex-col"
          } max-sm:gap-3 lg:flex-row w-[100vw] h-[100%] relative z-10`}
        >
          {showSidebar && (
            <div className="relative w-[300px] h-[100%] overflow-y-auto bg-black/80 backdrop-blur-sm border-r border-cyan-400/30 pr-3 pl-3 pb-3 scrollbar-custom max-sm:w-[100%] max-sm:h-[35%]">
              {/* Decorative sidebar border */}
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-cyan-400/50 via-pink-400/30 to-green-400/50"></div>

              {/* Toggle button */}
              <button
                onClick={() => setShowSidebar(false)}
                className="absolute top-1/2 right-0 transform -translate-y-1/2 z-30 bg-black/60 border border-cyan-400/50 text-cyan-400 h-8 w-6 hover:bg-cyan-400/10 hover:text-cyan-300 rounded-l-lg transition-all duration-300 flex items-center justify-center"
                title="Ẩn menu"
              >
                <svg
                  className="w-3 h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              {/* Authentication Status */}
              {(aiAuthStatus || mlopsAuthStatus) && (
                <div className="space-y-2 mt-3 mb-3">
                  {/* AI Authentication Status */}
                  {aiAuthStatus && (
                    <div className="p-3 bg-black/60 border border-cyan-400/50 rounded-xl backdrop-blur-sm">
                      <div className="flex items-center justify-between">
                      <button
                          onClick={handleAILogout}
                          className="text-white text-xs rounded-lg transition-colors font-mono"
                          title="Đăng xuất khỏi AI"
                        >
                        <div className="flex items-center justify-center text-xs text-cyan-300 font-mono">
                          <svg
                            className="w-3 h-3 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
                            />
                          </svg>
                          
                          AI UNLOCKED
                        </div>
                      
                        
                        </button>
                      </div>
                    </div>
                  )}

                  {/* MLOps Authentication Status */}
                  {mlopsAuthStatus && (
                    <div className="p-3 bg-black/60 border border-green-400/50 rounded-xl backdrop-blur-sm">
                      <div className="flex items-center justify-between">
                      <button
                          onClick={handleMLOpsLogout}
                          className=" text-white text-xs rounded-lg transition-colors font-mono"
                          title="Đăng xuất khỏi MLOps"
                        >
                        <div className="flex items-center text-xs text-green-300 font-mono">
                          <svg
                            className="w-3 h-3 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
                            />
                          </svg>
                          MLOPS UNLOCKED
                        </div>

                          
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              <ResourceAccordion
                onContentChange={handleContentChange}
                currentContent={currentContent}
                currentKey={currentContent.key}
              />
            </div>
          )}
          <div
            className={`relative ${
              showSidebar ? "w-[calc(100%-302px)]" : "w-full"
            } h-[100%] max-sm:w-[100%] max-sm:h-[calc(75%-60px)]`}
          >
            {/* Toggle button when sidebar is hidden */}
            {!showSidebar && (
              <button
                onClick={() => setShowSidebar(true)}
                className="absolute top-3 left-1 z-30 bg-black/60 border border-cyan-400/50 text-cyan-400 rounded-xl p-2 hover:bg-cyan-400/10 hover:text-cyan-300 transition-all duration-300 backdrop-blur-sm"
                title="Hiện menu"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            )}
            <div className="flex flex-col justify-center items-center w-[100%] h-[100%] gap-2 relative">
              <div className="w-[95%] h-[80%] bg-black/60 border border-cyan-400/30 rounded-2xl p-2 backdrop-blur-sm">
                {currentContent.video !== null &&
                currentContent.key !== null ? (
                  <video
                    src={currentContent.video}
                    controls
                    autoPlay
                    controlsList="nodownload"
                    className="w-full h-full rounded-xl video-player border-none focus:outline-none focus:ring-0 shadow-neon-cyan"
                  ></video>
                ) : (
                  <div className="flex flex-col justify-center items-center w-full h-full text-center">
                    <div className="w-16 h-16 border border-cyan-400/50 rounded-2xl flex items-center justify-center mb-4 bg-black/40">
                      <svg
                        className="w-8 h-8 text-cyan-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1.01M15 10h1.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <p className="text-cyan-300 font-mono text-sm">
                      <span className="text-cyan-400">{">"}</span>{" "}
                      [NEURAL_LEARNING_INTERFACE]
                    </p>
                    <p className="text-gray-400 font-mono text-xs mt-2 max-w-md">
                      Select topic from neural menu to initialize content matrix
                      🐶
                    </p>
                  </div>
                )}
              </div>
              <div className="flex items-center w-[95%] h-[8%]">
                <div className="rounded-xl flex justify-center items-center text-cyan-100 font-mono text-sm h-[100%] w-[fit-content] px-3 bg-black/40 border border-gray-600/50">
                  <span className="text-cyan-400 mr-2">{">"}</span>
                  {currentContent.title || "NO CONTENT SELECTED"}
                </div>
              </div>
              <div className="flex justify-between flex-row items-center w-[95%] h-[6%] gap-3 overflow-hidden">
                {currentContent.document != null && (
                  <button
                    onClick={handleFolderDialogToggle}
                    className="group relative h-8 px-3 bg-black/60 border border-yellow-400/50 text-yellow-300 rounded-xl hover:text-yellow-100 hover:shadow-neon-yellow font-mono text-xs transition-all duration-300 flex items-center gap-2 backdrop-blur-sm"
                    title="Xem tài liệu"
                  >
                    <Folder className="h-4 w-4 fill-current" />
                    DOCS
                    <div className="absolute inset-0 border border-yellow-400/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
                  </button>
                )}
                <div className="flex flex-row gap-2 h-[100%] justify-center items-center">
                  {/* Back Video Button */}
                  {currentContent.video && (
                    <button
                      onClick={handlePrevVideo}
                      className="group relative h-8 px-3 bg-black/60 border border-cyan-400/50 text-cyan-300 rounded-xl hover:text-cyan-100 hover:shadow-neon-cyan transition-all duration-300 flex items-center gap-1 backdrop-blur-sm font-mono text-xs"
                      title="Video trước"
                    >
                      <svg
                        className="w-3 h-3"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15.75 19.5 8.25 12l7.5-7.5"
                        />
                      </svg>
                      PREV
                      <div className="absolute inset-0 border border-cyan-400/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
                    </button>
                  )}
                  {/* Next Video Button */}
                  {currentContent.video && (
                    <button
                      onClick={handleNextVideo}
                      className="group relative h-8 px-3 bg-black/60 border border-green-400/50 text-green-300 rounded-xl hover:text-green-100 hover:shadow-neon-green transition-all duration-300 flex items-center gap-1 backdrop-blur-sm font-mono text-xs"
                      title="Video tiếp theo"
                    >
                      NEXT
                      <svg
                        className="w-3 h-3"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="m8.25 4.5 7.5 7.5-7.5 7.5"
                        />
                      </svg>
                      <div className="absolute inset-0 border border-green-400/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
                    </button>
                  )}
                </div>

                {folderDialog && (
                  <div className="fixed left-0 top-0 z-20 flex flex-row gap-2 items-center justify-center w-[100%] h-[100%] animate-fadeIn">
                    <div className="w-[100%] h-[100%] z-0 absolute bg-black/80 backdrop-blur-sm"></div>
                    {/* list documents */}
                    <div className="flex flex-col w-[60%] h-[60%] bg-black/90 border border-cyan-400/50 rounded-2xl overflow-hidden shadow-neon-cyan z-20 backdrop-blur-md animate-slideUp">
                      <div className="flex justify-between items-center w-full h-[40px] bg-black/60 border-b border-cyan-400/30 pr-4 pl-4">
                        <div className="flex items-center gap-3">
                          <span className="text-cyan-400 font-mono text-sm font-bold">
                            DOCUMENT MATRIX
                          </span>
                        </div>
                        <div className="flex space-x-2">
                          <button
                            className="w-3 h-3 bg-red-500 rounded-full hover:bg-red-400 transition-colors"
                            onClick={handleFolderDialogToggle}
                          ></button>
                          <button
                            className="w-3 h-3 bg-yellow-500 rounded-full hover:bg-yellow-400 transition-colors"
                            onClick={handleFolderDialogToggle}
                          ></button>
                          <button
                            className="w-3 h-3 bg-green-500 rounded-full hover:bg-green-400 transition-colors"
                            onClick={handleFolderDialogToggle}
                          ></button>
                        </div>
                      </div>
                      <div className="flex-1 overflow-auto text-sm w-[100%]">
                        <div className="divide-y divide-gray-700/50">
                          {currentContent.document.length === 0 && (
                            <div className="flex items-center justify-center px-4 w-[100%] h-[60px] bg-black/40 overflow-x-hidden text-gray-400 font-mono">
                              <span className="text-cyan-400 mr-2">{">"}</span>
                              NO DOCUMENTS AVAILABLE
                            </div>
                          )}
                          {currentContent.document.map((items, index) => (
                            <div key={index}>
                              <div
                                className={`group flex items-center justify-between px-4 w-[100%] h-[45px] overflow-x-hidden transition-all duration-300 cursor-pointer ${
                                  index % 2 === 0
                                    ? "bg-black/40 hover:bg-cyan-400/5"
                                    : "bg-black/60 hover:bg-cyan-400/5"
                                }`}
                              >
                                <span className="text-gray-300 font-mono text-xs group-hover:text-cyan-300 transition-colors">
                                  <span className="text-cyan-400 mr-2">
                                    {">"}
                                  </span>
                                  {items.title}
                                </span>
                                <div className="flex flex-row gap-2 items-center justify-center">
                                  {/* look */}
                                  <button
                                    onClick={() => handleDialogToggle(items)}
                                    className="group/btn relative flex items-center cursor-pointer p-2 rounded-lg bg-black/40 border border-green-400/30 hover:border-green-400 hover:bg-green-400/10 transition-all duration-300"
                                    title="Xem tài liệu"
                                  >
                                    <Eyes
                                      className="h-3 w-3 fill-green-400 group-hover/btn:fill-green-300"
                                      onClick={() =>
                                        setDocumentLink(items.link)
                                      }
                                    />
                                  </button>
                                  {/* download */}
                                  <a
                                    href={items.linkDownload}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group/btn relative flex items-center cursor-pointer p-2 rounded-lg bg-black/40 border border-pink-400/30 hover:border-pink-400 hover:bg-pink-400/10 transition-all duration-300 no-underline"
                                    title="Tải xuống"
                                  >
                                    <Downloads className="h-3 w-3 fill-pink-400 group-hover/btn:fill-pink-300" />
                                  </a>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Dialog loading */}
      {activeDialog && (
        <BubbleDocuments
          documentLink={documentLink}
          handleDocumentLoad={handleDocumentLoad}
          renderLoading={renderLoading}
          isLoading={isLoading}
          handleDialogToggle={handleDialogToggle}
        />
      )}

      {/* Dialog error */}
      {errorDialog && (
        <div className="fixed top-4 right-4 z-50 animate-slideIn">
          <div className="relative bg-black/90 border border-red-400/50 rounded-xl p-4 shadow-neon-pink backdrop-blur-md overflow-hidden max-w-sm">
            {/* Animated top border */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-red-400 to-transparent animate-slide-right rounded-t-xl"></div>
            
            {/* Background glow */}
            <div className="absolute -top-10 -right-10 w-20 h-20 bg-red-400/20 rounded-full blur-xl"></div>
            
            <div className="flex items-start space-x-3 relative z-10">
              {/* Network Error Icon */}
              <div className="flex-shrink-0 w-8 h-8 bg-black/60 border border-red-400/50 rounded-lg flex items-center justify-center shadow-neon-pink">
                <svg className="w-4 h-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v4m0 4h.01" />
                </svg>
              </div>
              
              <div className="flex-1">
                {/* Header */}
                <div className="flex items-center mb-2">
                  <span className="text-red-400 font-mono text-xs font-bold">[NETWORK_ERROR]</span>
                  <div className="w-2 h-2 bg-red-400 rounded-full ml-2 animate-pulse"></div>
                </div>
                
                {/* Message */}
                <p className="text-red-300 font-mono text-sm leading-relaxed">
                  <span className="text-red-400 mr-1">{'>'}</span>
                  Vui lòng kiểm tra lại đường truyền mạng
                </p>
              </div>
            </div>
            
            {/* Progress bar */}
            <div className="absolute bottom-0 left-0 h-1 bg-red-400/20 w-full">
              <div className="h-full bg-red-400 animate-progress-bar rounded-br-xl"></div>
            </div>
            
            {/* Corner accents */}
            <div className="absolute -top-1 -left-1 w-3 h-3 border-t border-l border-red-400/50 rounded-tl-xl"></div>
            <div className="absolute -bottom-1 -right-1 w-3 h-3 border-b border-r border-red-400/50 rounded-br-xl"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default Resources;
